import { useMemo } from 'react';

import { themeColors } from '@/theme/colors';

import { SensorStatus } from './SensorPlacement';

interface SensorPlacementProps {
  x: number;
  y: number;
  status: SensorStatus;
}

export const SensorHighlight = ({ x, y, status }: SensorPlacementProps) => {
  const [fillColor, strokeColor] = useMemo(() => {
    switch (status) {
      case 'selected':
        return [themeColors.sensorPlacementSelected, themeColors.sensorPlacementSelectedBorder];

      case 'error':
        return [themeColors.sensorPlacementError, themeColors.sensorPlacementErrorBorder];

      default:
        return [themeColors.sensorPlacementNotCalibrated, themeColors.sensorPlacementNotCalibratedBorder];
    }
  }, [status]);

  if (status === 'hidden') return null;

  return (
    <g>
      <circle cx={x} cy={y} fill={fillColor} r='4' />
      <circle cx={x} cy={y} r='6' stroke={strokeColor} strokeOpacity='0.2' strokeWidth='4' />
    </g>
  );
};
